import { get } from "lodash";
import { bool, func, object } from "prop-types";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { AD_LIMIT, TABOOLA_WIDGET_POSITION, TEADS_AD_POSITION } from "../../constants";
import { isAdPosition, isAdPositionWithTaboola } from "../utils/story";
import { getQueryParamsForArticleApi } from "../utils/utils";
import AdWrapper from "./atoms/AdWrapper";

export const WithStoryAds = ({ counter = {}, componentToRender, story }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));
  const sectionName = currentPath.split("?")[0].split("/")[1];
  const pageName = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_name_mapping", sectionName], "sections")
  );
  const networkId = useSelector((state) => get(state, ["qt", "config", "ads-config", "network_id"], ""));
  let storyPageAdUnit = `/${networkId}/GULFNEWS/Gulfnews_Article/gulfnews_${pageName}_article/gulfnews_${pageName}_article_`;
  const params = getQueryParamsForArticleApi(currentPath);
  if (params.articleApi) {
    storyPageAdUnit = `/${networkId}/GULFNEWS/Gulfnews_App/gulfnews_newapp_articles/gulfnews_newapp_articles_inarticle`;
  }
  const adsConfig = get(qtState, ["config", "ads-config"], {});

  const storyPageLhsAd = get(adsConfig, ["slots", "story_page_lhs_ad_1"], {});

  const noAds = get(qtState, ["config", "noAds"], false);
  counter.paragraphs++;
  const showAd =
    counter.ads < AD_LIMIT ? (params.articleApi ? isAdPosition(counter) : isAdPositionWithTaboola(counter)) : false;
  if (showAd) {
    counter.ads++;
  }
  const adRef = useRef(null);
  let storyIndex;
  if (adRef.current) {
    const closestInfiniteScrollParent = adRef.current.closest("[data-infinite-scroll]");
    storyIndex = get(closestInfiniteScrollParent, ["dataset", "infiniteScroll"], 0);
  }
  return (
    <div ref={adRef}>
      {componentToRender}
      {counter.paragraphs === TEADS_AD_POSITION && !noAds && <div id="teads-article-ad"></div>}
      {counter.paragraphs === TABOOLA_WIDGET_POSITION && !noAds && !params.articleApi && <div id="mid-article"></div>}
      {showAd && !noAds && storyIndex >= 0 && (
        <AdWrapper
          adStyleName="story-page-ad-slot"
          id={`div-gulfnews_sections_article_${parseInt(storyIndex) + 1}_${counter.ads}`}
          path={`${storyPageAdUnit}${counter.ads}`}
          size={storyPageLhsAd.sizes}
          viewPortSizeMapping={storyPageLhsAd.view_port_size_mapping}
          isLhsAd={true}
          count={counter.ads}
        />
      )}
    </div>
  );
};

WithStoryAds.propTypes = {
  counter: object,
  story: object,
  showAd: bool,
  isParagraph: bool,
  componentToRender: func,
};
